export default __webpack_public_path__ + "static/media/Lavamanos portada.bbf662d1.png";